import React from 'react';
import TabSec from './TabSec';
import SkinResultCustomizedSetting from './SkinResultCustomizedSetting';
import GetSkinResultCustomizedSetting from './GetSkinResultCustomizedSetting';

export default function CustomizedLayoutSettings({
  data,
  isLoading,
  selectedTempInfo,
  handleSelectedTemplate,
  tab = 'SmbSkincareResultPage',
  setTab,
}) {
  const tabBody = () => {
    if (tab === 'SmbSkincareResultPage') {
      return (
        <SkinResultCustomizedSetting
          data={data}
          isLoading={isLoading}
          selectedTempInfo={selectedTempInfo}
          handleSelectedTemplate={handleSelectedTemplate}
        />
      );
    }
    return <GetSkinResultCustomizedSetting />;
  };
  return (
    <div>
      <TabSec tab={tab} setTab={setTab} />
      {tabBody()}
    </div>
  );
}
